import { defineRequest, defineRequestWithParam } from "../axios"
import type {
    UploadFileInfoResponse,
    UploadFileListResponse,
    UploadListResponse,
    UploadStatusListResponse,
    UploadTypeListResponse,
} from "./types"

// 取得 uploads 列表
export const getUploadsFiles = defineRequest<UploadListResponse>({
    url: "/datahubs/uploads/",
    method: "get",
})

// 取得 上傳類型列表
export const getUploadsFilesType = defineRequest<UploadTypeListResponse>({
    url: "/datahubs/uploads/types/",
    method: "get",
})

// 取得 上傳狀態列表
export const getUploadsFilesStatus = defineRequest<UploadStatusListResponse>({
    url: "/datahubs/uploads/status/",
    method: "get",
})

// 上傳 upload 檔案
export const uploadUploadFile = defineRequest<void>({
    url: "/datahubs/uploads/",
    method: "post",
})

// 下載 上傳類型 範本檔案
export const downloadSampleFile = defineRequestWithParam<Blob>({
    url: (uploadType: string) => `/datahubs/uploads/${uploadType}/template/`,
    method: "get",
})

// 下載 uploads 檔案
export const downloadUploadFile = defineRequestWithParam<void>({
    url: (uuid: string) => `/datahubs/uploads/${uuid}/export/`,
    method: "get",
})

// 刪除 uploads 檔案
export const deleteUploadFile = defineRequestWithParam<void>({
    url: (uuid: string) => `/datahubs/uploads/${uuid}/`,
    method: "delete",
})

// 取得 uploads 資訊
export const getUploadFileInfo = defineRequestWithParam<UploadFileInfoResponse>({
    url: (uuid: string) => `/datahubs/uploads/${uuid}/`,
    method: "get",
})

// 取得 uploads 資料列表
export const getUploadFileList = defineRequestWithParam<UploadFileListResponse>({
    url: (uuid: string) => `/datahubs/uploads/${uuid}/list/`,
    method: "get",
})
